<template>
  <PageWrapper
    v-if="canView"
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_COURSES"
    title="Courses"
    sub-title="Manage your courses"
    :breadcrumbs="breadcrumbs"
    page-name="Courses"
    align="center"
    width="full"
    action-button-text="Create Course"
    @click:action="openCreateCourseModal"
  >
    <SmartFeed :source="useCourseFeedStore" default-feed-layout="table">
      <template #empty-state>
        <iSpace :height="50" />
        <iColumn gap="large" align="center">
          <iColumn gap="standard" align="center">
            <iSubHeading variant="subtle" font-size="large">
              No Courses Yet
            </iSubHeading>
            <iParagraph variant="subtle" text-align="center" :max-width="400">
              When you create a course, it'll appear here for easy access and
              management
            </iParagraph>
          </iColumn>
        </iColumn>
      </template>
    </SmartFeed>
    <CreateCourse />
  </PageWrapper>
  <iText v-else>
    You don't have access to view this page.
  </iText>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import CreateCourse from "@/components/publication/courses/CreateCourse.vue";
import { mapState, mapActions } from "pinia";
import {
  PAGE_PUBLICATION_COURSES,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useCourseStore } from "@/stores/course-store";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { useCourseFeedStore } from "@/smart-feed/stores/feed/course-feed-store";
import { useCollaboratorStore } from "@/stores/collaborator-store";

export default {
  name: "PublicationCourses",
  components: { SmartFeed, PageWrapper, CreateCourse },
  data() {
    return {
      PAGE_PUBLICATION_COURSES,
      SECTION_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "orgId",
      "publicationId",
    ]),
    ...mapState(useCourseStore, [
      "isLoading",
    ]),
    ...mapState(useCollaboratorStore, [
      "canView",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        {
          url: `/publication/${this.publicationId}`,
          label: "Overview",
        },
      ];
    },
  },
  mounted() {
    if (!this.canView) {
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/publication/${this.publicationId}`;

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    }
  },
  methods: {
    useCourseFeedStore,
    ...mapActions(useCourseStore, ["openCreateCourseModal"]),
  },
};
</script>

<style scoped lang="scss"></style>
